import { z } from 'zod';
import { templateComponentCanvasSchema } from './base';
import { templateCheckboxSchema } from './checkbox';
import { templateClinicalSignatureSchema } from './clinical-signature';
import { templateDatePickerSchema } from './date-picker';
import { templateDateRangePickerSchema } from './date-range-picker';
import { templateHeadingSchema } from './heading';
import { templateImageSchema } from './image';
import { templateInputSchema } from './input';
import { templateNumberSelectSchema } from './number-selector';
import { templatePainScaleSchema } from './pain-scale';
import { templateParagraphSchema } from './paragraph';
import { templateRadioSchema } from './radio';
import { templateScoreTableSchema } from './score-table';
import { templateSelectSchema } from './select';
import { templateSeparatorSchema } from './separator';
import { templateSignatureSchema } from './signature';
import { templateTableSchema } from './table';
import { templateTextEditorSchema } from './text-editor';
import { templateTextareaSchema } from './textarea';
import { templateTimePickerSchema } from './time-picker';

export const templateWidgetSchema = z.union([
  templateInputSchema,
  templateNumberSelectSchema,
  templateHeadingSchema,
  templateCheckboxSchema,
  templateParagraphSchema,
  templateRadioSchema,
  templateTextareaSchema,
  templateSelectSchema,
  templateTextEditorSchema,
  templateImageSchema,
  templatePainScaleSchema,
  templateScoreTableSchema,
  templateTableSchema,
  templateSeparatorSchema,
  templateDatePickerSchema,
  templateDateRangePickerSchema,
  templateTimePickerSchema,
  templateSignatureSchema,
  templateClinicalSignatureSchema,
]);
export type TemplateWidget = z.infer<typeof templateWidgetSchema>;

export const SCHEMA_VERSION = '9';

export const templateSchema = z.object({
  version: z.literal(SCHEMA_VERSION),
  canvas: z.record(z.string(), templateComponentCanvasSchema),
  widgets: z.record(z.string(), templateWidgetSchema),
  /**
   * 畫布頁數（A4 page 數量）
   * - 用於 UI 計算分頁與 BreakPoint
   */
  pageCount: z.number().int().min(1).default(1),
});

export type TemplateSchema = z.infer<typeof templateSchema>;
export type WidgetRect = TemplateSchema['canvas'][string];
export type WidgetData = TemplateSchema['widgets'][string];
